import QRCodeHTMLComponent from '@/components/QRCodeHTMLComponent'
import vuewidget from './vuewidget'

export default function(dom, opts) {
	let options = {
		...opts,
		vueComponent: QRCodeHTMLComponent,
		vueInit: null,
	}

	let page = vuewidget(dom, options)
	return page
}
